import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import AuthProvider from "./context/AuthContext";
import ThemeProvider from "./context/ThemeContext";
import { ClerkProvider } from '@clerk/clerk-react';
// const PUBLISHABLE_KEY = 'pk_test_Z3VpZGVkLW1vbmFyY2gtNTIuY2xlcmsuYWNjb3VudHMuZGV2JA'; 
const PUBLISHABLE_KEY = 'pk_live_Y2xlcmsudmVzdHIuaW8k';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
          <App />
        </ClerkProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
